{/*}
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const backendURL = "http://localhost:8000/auth/reset-password"; // your FastAPI endpoint

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("token");
    setToken(t || "");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setMessage("Invalid or missing token.");
      return;
    }
    if (password !== confirm) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(backendURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          new_password: password,
          confirm_password: confirm,
        }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage("✅ Password reset successful! Redirecting to login...");
        setTimeout(() => navigate("/"), 2000);
      } else {
        setMessage(data.detail || data.message || "Password reset failed.");
      }
    } catch (err) {
      setMessage("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <div className="input-wrap">
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="input-wrap">
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>

        {message && (
          <p
            className={`${
              message.startsWith("✅") ? "success" : "field-error"
            }`}
          >
            {message}
          </p>
        )}

        <button className="primary" type="submit" disabled={loading}>
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </div>
  );
}


*/}


{/*
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [pwdError, setPwdError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serverMsg, setServerMsg] = useState("");
  const [success, setSuccess] = useState(false);

  // Extract reset token from URL
  const token = new URLSearchParams(window.location.search).get("token");

  const validatePassword = (pwd) => {
    const re =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    return re.test(pwd);
  };

  const generateStrongPassword = (len = 12) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@$!%*#?&";
    let out = "";
    for (let i = 0; i < len; i++)
      out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  };

  const applySuggestion = (s) => {
    setPassword(s);
    setConfirm(s);
    setSuggestion("");
    setPwdError("");
    setConfirmError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerMsg("");

    if (!token) {
      setServerMsg("Invalid or missing reset token.");
      return;
    }
    if (!validatePassword(password)) {
      setPwdError("Password is too weak.");
      return;
    }
    if (password !== confirm) {
      setConfirmError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch("http://localhost:8000/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          new_password: password,
          confirm_password: confirm,
        }),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.detail || "Password reset failed");
      }

      setSuccess(true);
      setServerMsg("✅ Password reset successful! Redirecting to login...");
      setTimeout(() => navigate("/"), 2500);
    } catch (err) {
      console.error(err);
      setServerMsg(err.message || "Invalid or expired reset token");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-container"
      style={{
        maxWidth: 400,
        margin: "50px auto",
        background: "#fff",
        borderRadius: 10,
        padding: 30,
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#1e2a78" }}>Reset Password</h2>

      <form onSubmit={handleSubmit}>
        {/* === New Password Field === 
        <div
          className="input-wrap"
          style={{ position: "relative", marginBottom: "20px" }}
        >
          <input
            type={showPassword ? "text" : "password"}
            placeholder="New Password"
            value={password}
            onChange={(e) => {
              const v = e.target.value;
              setPassword(v);
              setSuggestion("");
              if (!validatePassword(v)) {
                setPwdError("Weak password");
                if (!suggestion) setSuggestion(generateStrongPassword(12));
              } else {
                setPwdError("");
                setSuggestion("");
              }
            }}
            required
            style={{
              width: "100%",
              paddingRight: "40px",
              boxSizing: "border-box",
            }}
          />
          <span
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              top: "0",
              bottom: "0",
              right: "10px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#555",
              fontSize: "18px",
              userSelect: "none",
            }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          {pwdError && <div className="field-error">{pwdError}</div>}
          {suggestion && (
            <div
              className="password-suggestion"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "4px",
              }}
            >
              <div>
                Suggested strong password:{" "}
                <code
                  style={{
                    fontSize: 13,
                    padding: "2px 6px",
                    background: "#f3f4f6",
                    borderRadius: 6,
                  }}
                >
                  {suggestion}
                </code>
              </div>
              <button
                type="button"
                className="btn-compact"
                onClick={() => applySuggestion(suggestion)}
              >
                Use
              </button>
            </div>
          )}
        </div>

        {/* === Confirm Password Field === 
        <div
          className="input-wrap"
          style={{ position: "relative", marginBottom: "20px" }}
        >
          <input
            type={showConfirm ? "text" : "password"}
            placeholder="Confirm Password"
            value={confirm}
            onChange={(e) => {
              setConfirm(e.target.value);
              if (password !== e.target.value)
                setConfirmError("Passwords do not match");
              else setConfirmError("");
            }}
            required
            style={{
              width: "100%",
              paddingRight: "40px",
              boxSizing: "border-box",
            }}
          />
          <span
            onClick={() => setShowConfirm(!showConfirm)}
            style={{
              position: "absolute",
              top: "0",
              bottom: "0",
              right: "10px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#555",
              fontSize: "18px",
              userSelect: "none",
            }}
          >
            {showConfirm ? <FaEyeSlash /> : <FaEye />}
          </span>
          {confirmError && <div className="field-error">{confirmError}</div>}
        </div>

        {/* === Submit Button === *
        <button
          className="primary"
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            background: "#4765a0",
            color: "#fff",
            padding: "10px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </button>
      </form>

      {/* Server message *
      {serverMsg && (
        <p
          style={{
            marginTop: 15,
            textAlign: "center",
            color: success ? "green" : "red",
          }}
        >
          {serverMsg}
        </p>
      )}
    </div>
  );
}
*/}

// added this code 31-10-2025

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaEyeSlash, FaEye } from "react-icons/fa";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [pwdError, setPwdError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // 🔹 new states for backend communication
  const [loading, setLoading] = useState(false);
  const [serverMsg, setServerMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState("");

  // 🔹 extract token from URL once
  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("token");
    setToken(t || "");
  }, []);

  const validatePassword = (pwd) => {
    const re =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    return re.test(pwd);
  };

  const generateStrongPassword = (len = 12) => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@$!%*#?&";
    let out = "";
    for (let i = 0; i < len; i++)
      out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  };

  const applySuggestion = (s) => {
    setPassword(s);
    setConfirm(s);
    setSuggestion("");
    setPwdError("");
    setConfirmError("");
  };

  // 🔹 handle submit to backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerMsg("");

    if (!token) {
      setServerMsg("Invalid or missing reset token.");
      return;
    }
    if (!validatePassword(password)) {
      setPwdError("Password is too weak.");
      return;
    }
    if (password !== confirm) {
      setConfirmError("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch("http://localhost:8001/auth/reset-password", {
      //fetch(`${process.env.REACT_APP_API_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token,
          new_password: password,
          confirm_password: confirm,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || data.message || "Reset failed");

      setSuccess(true);
      setServerMsg("✅ Password reset successful! Redirecting to login...");
      setTimeout(() => navigate("/"), 2500);
    } catch (err) {
      console.error(err);
      setServerMsg(err.message || "Invalid or expired reset token");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2>Reset your Password</h2>

      {/* === FORM START === */}
      <form onSubmit={handleSubmit}>
        {/* === New Password Field === */}
        <div
          className="input-wrap"
          style={{ position: "relative", marginBottom: "20px" }}
        >
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New Password"
              value={password}
              onChange={(e) => {
                const v = e.target.value;
                setPassword(v);
                setSuggestion("");
                if (!validatePassword(v)) {
                  setPwdError("Weak password");
                  if (!suggestion) setSuggestion(generateStrongPassword(12));
                } else {
                  setPwdError("");
                  setSuggestion("");
                }
              }}
              required
              style={{
                width: "100%",
                paddingRight: "40px",
                boxSizing: "border-box",
              }}
            />

            {/* 👁 Eye Icon — stays fixed inside input */}
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                top: "0",
                bottom: "0",
                right: "10px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#555",
                fontSize: "18px",
                userSelect: "none",
              }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {pwdError && <div className="field-error">{pwdError}</div>}

          {suggestion && (
            <div
              className="password-suggestion"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "4px",
              }}
            >
              <div>
                Suggested strong password:{" "}
                <code
                  style={{
                    fontSize: 13,
                    padding: "2px 6px",
                    background: "#f3f4f6",
                    borderRadius: 6,
                  }}
                >
                  {suggestion}
                </code>
              </div>
              <button
                type="button"
                className="btn-compact"
                onClick={() => applySuggestion(suggestion)}
                aria-label="Use suggested password"
              >
                Use
              </button>
            </div>
          )}
        </div>

        {/* === Confirm Password Field === */}
        <div
          className="input-wrap"
          style={{ position: "relative", marginBottom: "20px" }}
        >
          <div style={{ position: "relative" }}>
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm New Password"
              value={confirm}
              onChange={(e) => {
                setConfirm(e.target.value);
                if (password !== e.target.value)
                  setConfirmError("Passwords do not match");
                else setConfirmError("");
              }}
              required
              style={{
                width: "100%",
                paddingRight: "40px",
                boxSizing: "border-box",
              }}
            />

            {/* 👁 Eye Icon — fixed position */}
            <span
              onClick={() => setShowConfirm(!showConfirm)}
              style={{
                position: "absolute",
                top: "0",
                bottom: "0",
                right: "10px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#555",
                fontSize: "18px",
                userSelect: "none",
              }}
            >
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {confirmError && <div className="field-error">{confirmError}</div>}
        </div>

        {/* === Submit Button === */}
        <button className="primary" type="submit" disabled={loading}>
          {loading ? "Resetting..." : "Change Password"}
        </button>

        {/* === Server Message === */}
        {serverMsg && (
          <p
            style={{
              marginTop: "12px",
              textAlign: "center",
              color: success ? "green" : "red",
            }}
          >
            {serverMsg}
          </p>
        )}
      </form>
      {/* === FORM END === */}
    </div>
  );
}